export default "__VITE_ASSET__63B7_hKU__"